import { Component, Input, OnInit } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { TranslocoModule } from '@jsverse/transloco';
import { ListPageColumnComponent } from 'design-system';

@Component({
  selector: 'prd-category-chip',
  imports: [MatChipsModule, TranslocoModule],
  templateUrl: './category-chip.html',
  styleUrl: './category-chip.scss',
})
export class CategoryChip extends ListPageColumnComponent implements OnInit {
  @Input() badges: string[] = [];

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.badges = this.itemData[this.infoColumn.columnNameDef] ?? [];
    }
  }
}
